export const isEdge = window.navigator.userAgent.indexOf('Edge') !== -1;
